import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { PriceAmounts } from '@sm360/widget-commons-general';

import CurrencyFormats from 'commons-vehicle/constants/currencyFormats.js';

import 'commons-vehicle/Quote/components/TransactionSummary/AmountLineItem/AmountLineItem.scss';

const AmountLineItemWithIcon = ({ amount, icon, label }) => {
    const iconClass = icon ? `icon-${icon}` : 'icon';
    const iconElem = <icon className={iconClass} />;

    return amount !== 0 ? (
        <li className="amountLineItemWithIcon clearfix">
            <span className="label">
                {icon && iconElem}
                {label}
            </span>
            <span className="value sr-text-bold">
                <PriceAmounts price={LocaleService.l(amount, CurrencyFormats.CURRENCY_2)} />
            </span>
        </li>
    ) : (
        <li className="amountLineItemWithIcon clearfix">
            <span className="label">
                {icon && iconElem}
                {label}
            </span>
            <span className="value sr-text-bold">
                <PriceAmounts price={LocaleService.t('SUMMARY.PRICE_ON_DEMAND')} />
            </span>
        </li>
    );
};

AmountLineItemWithIcon.propTypes = {
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
};

AmountLineItemWithIcon.displayName = 'AmountLineItemWithIcon';

export default AmountLineItemWithIcon;
